/* Wild Thingz theme - global JS (vanilla, no dependencies) */
(function () {
  'use strict';

  var routes = { cartAdd: '/cart/add.js', cartChange: '/cart/change.js', cartUpdate: '/cart/update.js' };

  /* ---------- Helpers ---------- */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function trapOpen(panel, opener) {
    panel.setAttribute('data-open', 'true');
    panel.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    if (opener) opener.setAttribute('aria-expanded', 'true');
  }
  function trapClose(panel, opener) {
    panel.setAttribute('data-open', 'false');
    panel.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (opener) opener.setAttribute('aria-expanded', 'false');
  }

  /* ---------- Mobile nav ---------- */
  var mobileNav = qs('#MobileNav');
  var menuOpenBtns = qsa('[data-menu-open]');
  var menuCloseBtns = qsa('[data-menu-close]');
  menuOpenBtns.forEach(function (btn) {
    btn.addEventListener('click', function () { if (mobileNav) trapOpen(mobileNav, btn); });
  });
  menuCloseBtns.forEach(function (btn) {
    btn.addEventListener('click', function () { if (mobileNav) trapClose(mobileNav, menuOpenBtns[0]); });
  });
  /* Force-close the mobile nav whenever a nav link is clicked, so anchor links to a
     section further down the page (which don't trigger a full page navigation) don't
     leave the drawer open over the newly-scrolled-to content. */
  if (mobileNav) {
    qsa('a', mobileNav).forEach(function (link) {
      link.addEventListener('click', function () { trapClose(mobileNav, menuOpenBtns[0]); });
    });
  }

  /* ---------- Search modal ---------- */
  var searchModal = qs('[data-search-modal]');
  qsa('[data-search-open]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!searchModal) return;
      trapOpen(searchModal, btn);
      var input = qs('input[type="search"]', searchModal);
      if (input) input.focus();
    });
  });
  qsa('[data-search-close]').forEach(function (btn) {
    btn.addEventListener('click', function () { if (searchModal) trapClose(searchModal); });
  });

  /* ---------- Predictive search (header search modal) ----------
     Typing 2+ characters fetches sections/predictive-search.liquid through Shopify's
     predictive search API and swaps it into the listbox. Debounced, cancels stale
     requests, caches recent terms. Arrow keys move through results, Enter opens the
     highlighted one, Escape clears the box (a second Escape closes the modal).
     Without JS the form still submits to /search. */
  (function () {
    var form = searchModal && qs('[data-ps]', searchModal);
    if (!form) return;
    var input = qs('[data-ps-input]', form);
    var panel = qs('[data-ps-panel]', searchModal);
    var status = qs('[data-ps-status]', searchModal);
    if (!input || !panel) return;
    var emptyHtml = panel.innerHTML;
    var cache = {};
    var timer = null;
    var ctrl = null;
    var active = -1;
    var lastTerm = '';

    function options() { return qsa('[role="option"]', panel); }
    function setExpanded() {
      var has = options().length > 0;
      input.setAttribute('aria-expanded', has ? 'true' : 'false');
      panel.classList.toggle('is-open', panel.innerHTML.trim() !== '');
    }
    function setActive(i) {
      var opts = options();
      opts.forEach(function (o) { o.setAttribute('aria-selected', 'false'); });
      active = i;
      if (i < 0 || !opts[i]) { input.removeAttribute('aria-activedescendant'); return; }
      opts[i].setAttribute('aria-selected', 'true');
      input.setAttribute('aria-activedescendant', opts[i].id);
      opts[i].scrollIntoView({ block: 'nearest' });
    }
    function announce(text) { if (status) status.textContent = text; }
    function show(html, count) {
      panel.innerHTML = html;
      active = -1;
      input.removeAttribute('aria-activedescendant');
      setExpanded();
      if (count != null) {
        var tpl = panel.getAttribute('data-ps-announce') || '[count] results';
        announce(count > 0 ? tpl.replace('[count]', count) : (qs('.wt-ps__none', panel) || {}).textContent || '');
      }
    }
    function reset() {
      if (ctrl) ctrl.abort();
      lastTerm = '';
      show(emptyHtml, null);
      announce('');
    }
    function fetchResults(term) {
      if (cache[term]) { show(cache[term].html, cache[term].count); return; }
      if (ctrl) ctrl.abort();
      ctrl = window.AbortController ? new AbortController() : null;
      var url = form.getAttribute('data-ps-url') + '?q=' + encodeURIComponent(term) +
        '&resources[type]=' + encodeURIComponent(form.getAttribute('data-ps-types') || 'product') +
        '&resources[limit]=' + (form.getAttribute('data-ps-limit') || 4) +
        '&resources[limit_scope]=each&resources[options][fields]=title,product_type,variants.title,vendor,tag' +
        '&section_id=predictive-search';
      panel.setAttribute('aria-busy', 'true');
      fetch(url, ctrl ? { signal: ctrl.signal } : {})
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var res = qs('[data-ps-results]', doc);
          if (!res) return;
          var entry = { html: res.innerHTML, count: parseInt(res.getAttribute('data-ps-count'), 10) || 0 };
          cache[term] = entry;
          if (term === lastTerm) show(entry.html, entry.count);
        })
        .catch(function () {})
        .finally(function () { panel.removeAttribute('aria-busy'); });
    }

    input.addEventListener('input', function () {
      var term = input.value.trim();
      clearTimeout(timer);
      if (term.length < 2) { reset(); return; }
      lastTerm = term;
      timer = setTimeout(function () { fetchResults(term); }, 250);
    });
    input.addEventListener('keydown', function (e) {
      var opts = options();
      if (e.key === 'ArrowDown' && opts.length) { e.preventDefault(); setActive(active + 1 >= opts.length ? 0 : active + 1); }
      else if (e.key === 'ArrowUp' && opts.length) { e.preventDefault(); setActive(active - 1 < 0 ? opts.length - 1 : active - 1); }
      else if (e.key === 'Enter' && active >= 0 && opts[active]) {
        var link = qs('a', opts[active]);
        if (link) { e.preventDefault(); link.click(); }
      }
      else if (e.key === 'Escape' && input.value) { e.preventDefault(); e.stopPropagation(); input.value = ''; reset(); }
    });
    panel.addEventListener('mousemove', function (e) {
      var opt = e.target.closest('[role="option"]');
      if (opt) { var i = options().indexOf(opt); if (i !== active) setActive(i); }
    });
    setExpanded();
  })();

  /* ---------- Basket drawer + chomping plant ---------- */
  var cartDrawer = qs('#CartDrawer');
  var reducedMotion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var chompTimers = [];
  var chompSvgPromise = null;

  function chompEl() { return cartDrawer ? qs('[data-chomp]', cartDrawer) : null; }
  function loadChomp() {
    var slot = chompEl();
    if (!slot || !window.WT || !window.WT.chompUrl) return Promise.resolve(null);
    if (!chompSvgPromise) {
      chompSvgPromise = fetch(window.WT.chompUrl)
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (txt) {
          if (!txt) return null;
          slot.innerHTML = txt;
          var svg = qs('svg', slot);
          if (svg) { svg.classList.add('wt-chomp'); svg.setAttribute('data-frame', '1'); svg.removeAttribute('role'); svg.setAttribute('aria-hidden', 'true'); }
          return svg;
        })
        .catch(function () { return null; });
    }
    return chompSvgPromise;
  }
  function clearChomp() { chompTimers.forEach(clearTimeout); chompTimers = []; }
  function at(ms, fn) { chompTimers.push(setTimeout(fn, ms)); }
  function plantState(state) {
    var slot = chompEl();
    if (!slot) return;
    slot.classList.remove('is-up', 'is-rest');
    if (state) slot.classList.add('is-' + state);
  }
  function plantInstant(state) {
    var slot = chompEl();
    if (!slot) return;
    slot.classList.add('is-instant');
    plantState(state);
    void slot.offsetWidth;
    slot.classList.remove('is-instant');
  }
  function setFrame(n) { var svg = chompEl() && qs('svg', chompEl()); if (svg) svg.setAttribute('data-frame', String(n)); }

  function setCartOpen(open) {
    if (!cartDrawer) return;
    if (open) {
      trapOpen(cartDrawer);
      var closeBtn = qs('.wt-drawer__close', cartDrawer);
      if (closeBtn) closeBtn.focus({ preventScroll: true });
    } else {
      trapClose(cartDrawer);
    }
  }
  function isCartOpen() { return cartDrawer && cartDrawer.getAttribute('data-open') === 'true'; }

  function bumpBasket() {
    qsa('.wt-basket-btn').forEach(function (btn) {
      btn.classList.add('is-bump');
      setTimeout(function () { btn.classList.remove('is-bump'); }, 160);
    });
  }
  function announce(msg) { var live = cartDrawer && qs('[data-cart-live]', cartDrawer); if (live) { live.textContent = ''; setTimeout(function () { live.textContent = msg; }, 50); } }

  /* Open after an add: the plant rises, chomps (count bumps on frame 4), then sinks to rest.
     Timings from the approved prototype: rise 420ms, chomp starts 280ms in, sink starts
     100ms before the last frame ends. */
  function openAfterAdd(title) {
    clearChomp();
    var wasOpen = isCartOpen();
    if (!wasOpen) plantInstant(null);
    setCartOpen(true);
    var msg = (window.WT && window.WT.addedText ? window.WT.addedText : '__TITLE__ added to basket').replace('__TITLE__', title || 'Item');
    if (reducedMotion.matches || !chompEl()) { plantInstant('rest'); bumpBasket(); announce(msg); return; }
    loadChomp().then(function (svg) {
      if (!svg) { plantInstant('rest'); bumpBasket(); announce(msg); return; }
      setFrame(1);
      var t0 = wasOpen ? 0 : 280;
      at(t0, function () { plantState('up'); });
      var seq = [[2, 110], [3, 220], [4, 150], [5, 120], [6, 140]];
      var t = t0 + 280;
      seq.forEach(function (step) {
        var f = step[0];
        at(t, function () { setFrame(f); if (f === 4) { bumpBasket(); announce(msg); } });
        t += step[1];
      });
      at(t - 100, function () { plantState('rest'); });
      at(t, function () { setFrame(1); });
    });
  }
  function openFromHeader() {
    clearChomp();
    loadChomp().then(function () { setFrame(1); });
    plantInstant('rest');
    setCartOpen(true);
  }
  function closeCartDrawer() {
    clearChomp();
    setCartOpen(false);
    setTimeout(function () { if (!isCartOpen()) { plantInstant(null); setFrame(1); } }, 320);
  }

  qsa('[data-cart-open]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      if (!cartDrawer) return;
      e.preventDefault();
      openFromHeader();
    });
  });
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-close]')) closeCartDrawer();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (isCartOpen()) closeCartDrawer();
    if (mobileNav && mobileNav.getAttribute('data-open') === 'true') trapClose(mobileNav, menuOpenBtns[0]);
    if (searchModal && searchModal.getAttribute('data-open') === 'true') trapClose(searchModal);
  });

  function refreshCartDrawer() {
    if (!cartDrawer) return Promise.resolve();
    return fetch(window.location.pathname + '?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-drawer-content]');
        var current = qs('[data-drawer-content]', cartDrawer);
        if (fresh && current) current.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  }

  function updateCartCount(count) {
    qsa('[data-cart-count]').forEach(function (el) { el.textContent = count; });
    qsa('.wt-basket-btn').forEach(function (btn) {
      btn.setAttribute('aria-label', (btn.getAttribute('data-cart-label') || 'Basket') + ', ' + count);
    });
  }

  function refreshCartState() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        updateShipTrackers(cart);
        document.dispatchEvent(new CustomEvent('wt:cart', { detail: cart }));
        return cart;
      });
  }

  /* Free delivery tracker on product pages (main-product buy buttons): message + progress bar
     follow the basket total after every add / quantity change. */
  function formatMoney(pence, currency) {
    try { return new Intl.NumberFormat('en-GB', { style: 'currency', currency: currency || 'GBP' }).format(pence / 100); }
    catch (e) { return '£' + (pence / 100).toFixed(2); }
  }
  function updateShipTrackers(cart) {
    qsa('[data-ship]').forEach(function (el) {
      var to = parseInt(el.getAttribute('data-ship-to'), 10) || 1900;
      var total = cart.total_price || 0;
      var pct = Math.min(100, Math.floor(total * 100 / to));
      var msg = qs('[data-ship-msg]', el);
      var bar = qs('[data-ship-bar]', el);
      var wasDone = el.classList.contains('is-done');
      if (el.hasAttribute('data-ship-static')) return;
      el.classList.toggle('is-active', total > 0);
      el.classList.toggle('is-done', pct >= 100);
      if (msg) {
        if (total <= 0) msg.textContent = el.getAttribute('data-ship-note');
        else if (pct >= 100) msg.textContent = el.getAttribute('data-ship-done');
        else {
          var parts = (el.getAttribute('data-ship-away') || '[amount]').split('[amount]');
          msg.textContent = '';
          parts.forEach(function (t, i) {
            if (i > 0) { var b = document.createElement('b'); b.textContent = formatMoney(to - total, cart.currency); msg.appendChild(b); }
            msg.appendChild(document.createTextNode(t));
          });
        }
      }
      if (bar) { bar.setAttribute('aria-valuenow', pct); var f = qs('span', bar); if (f) f.style.width = pct + '%'; }
      if (total > 0 && (pct < 100 || !wasDone)) { el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump'); }
    });
  }

  function addToCart(body, isJson, title) {
    var opts = { method: 'POST', headers: { Accept: 'application/json' }, body: body };
    if (isJson) opts.headers['Content-Type'] = 'application/json';
    return fetch(routes.cartAdd, opts)
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (item) { return refreshCartDrawer().then(function () { return refreshCartState(); }).then(function () { return item; }); })
      .then(function (item) { openAfterAdd(title || (item && item.product_title)); });
  }

  /* Add to basket (product form) */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('.product-form');
    if (!form || !cartDrawer) return;
    e.preventDefault();
    var btn = form.querySelector('[data-add-to-cart]');
    if (btn) btn.setAttribute('disabled', 'disabled');
    addToCart(new FormData(form), false, form.getAttribute('data-product-title'))
      .catch(function (err) { console.error(err); if (err && err.description) window.alert(err.description); })
      .finally(function () { if (btn) btn.removeAttribute('disabled'); });
  });

  /* Quick add (pack cards, hotspots, product cards) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    var id = btn.getAttribute('data-product-id');
    if (!id) return;
    btn.setAttribute('disabled', 'disabled');
    addToCart(JSON.stringify({ id: id, quantity: 1 }), true, btn.getAttribute('data-product-title'))
      .catch(function (err) { console.error(err); })
      .finally(function () { btn.removeAttribute('disabled'); });
  });

  /* ---------- Shop the range: close an open card on outside tap / Escape (animated mode) ---------- */
  function closeHotspots(wrap) {
    qsa('[data-hotspot]', wrap).forEach(function (s) {
      s.classList.remove('is-open');
      var t = qs('[data-hotspot-toggle]', s);
      if (t) t.setAttribute('aria-expanded', 'false');
    });
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-hotspot]')) return;
    qsa('[data-hotspots][data-animate]').forEach(closeHotspots);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') qsa('[data-hotspots][data-animate]').forEach(closeHotspots);
  });

  /* ---------- Reveal-on-scroll for animated sections ----------
     Elements with [data-reveal] inside a section with [data-animate] get .is-inview once they
     scroll into view. The hidden start states in base.css only apply once html has
     .wt-reveal-ready, so if this script never runs everything simply shows at rest. */
  (function () {
    var targets = qsa('[data-animate] [data-reveal]');
    if (!targets.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-inview'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-inview');
        io.unobserve(entry.target);
      });
    }, { threshold: 0.25, rootMargin: '0px 0px -8% 0px' });
    targets.forEach(function (el) { io.observe(el); });
    document.documentElement.classList.add('wt-reveal-ready');
  })();

  /* ---------- Shop the range hotspots ---------- */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-hotspot-toggle]');
    if (!toggle) return;
    var spot = toggle.closest('[data-hotspot]');
    var wrap = toggle.closest('[data-hotspots]');
    if (!spot || !wrap) return;
    var closing = wrap.hasAttribute('data-animate') && spot.classList.contains('is-open');
    qsa('[data-hotspot]', wrap).forEach(function (s) {
      var open = s === spot && !closing;
      s.classList.toggle('is-open', open);
      var t = qs('[data-hotspot-toggle]', s);
      if (t) t.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  /* Cart line remove (drawer + page) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cart-remove]');
    if (!btn) return;
    var item = btn.closest('[data-key]');
    var key = item ? item.getAttribute('data-key') : btn.getAttribute('data-key');
    if (!key) return;
    fetch(routes.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return refreshCartState(); })
      .then(function () {
        if (document.body.classList.contains('template-cart')) {
          window.location.reload();
        } else {
          return refreshCartDrawer();
        }
      })
      .catch(function (err) { console.error(err); });
  });

  /* Quantity steppers (drawer + product form + cart page) */
  document.addEventListener('click', function (e) {
    var stepBtn = e.target.closest('[data-quantity-increase], [data-quantity-decrease]');
    if (!stepBtn) return;
    var wrapper = stepBtn.closest('[data-quantity-wrapper]');
    var input = wrapper && wrapper.querySelector('[data-quantity-input]');
    if (!input) return;
    var min = parseInt(input.min || '0', 10);
    var value = parseInt(input.value || '1', 10);
    value = stepBtn.hasAttribute('data-quantity-increase') ? value + 1 : Math.max(min, value - 1);
    input.value = value;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-quantity-input]');
    if (!input) return;
    var cartItem = input.closest('[data-cart-item]');
    if (!cartItem) return; // inside a form (e.g. product page) - no AJAX needed here
    var key = cartItem.getAttribute('data-key');
    var qty = Math.max(0, parseInt(input.value || '0', 10));
    fetch(routes.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return refreshCartState(); })
      .then(function () {
        if (document.body.classList.contains('template-cart')) {
          window.location.reload();
        } else {
          return refreshCartDrawer();
        }
      })
      .catch(function (err) { console.error(err); });
  });

  /* ---------- Halloween form modal ---------- */
  var hfModal = qs('#HalloweenFormModal');

  function openHfModal() { if (hfModal) trapOpen(hfModal); }
  function closeHfModal() { if (hfModal) trapClose(hfModal); }

  /* Exposed so the section's own inline script can force it open/closed
     while it's selected in the theme editor (shopify:section:select). */
  window.WT_openHalloweenForm = openHfModal;
  window.WT_closeHalloweenForm = closeHfModal;

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('a[href$="#halloween-form"], [data-hf-modal-open]');
    if (opener) {
      e.preventDefault();
      openHfModal();
      return;
    }
    if (e.target.closest('[data-hf-modal-close]')) closeHfModal();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && hfModal && hfModal.getAttribute('data-open') === 'true') closeHfModal();
  });

  /* ---------- Promo popup (sections/wt-promo.liquid) ---------- */
  var promo = qs('[data-promo]');
  if (promo) {
    var promoKey = 'wt-promo-' + (promo.getAttribute('data-promo-id') || 'promo');
    var promoDays = parseFloat(promo.getAttribute('data-promo-days')) || 0;
    var promoDelay = (parseFloat(promo.getAttribute('data-promo-delay')) || 0) * 1000;
    var promoLastFocus = null;

    var promoSeen = function () {
      if (promoDays <= 0) return false;
      try {
        var t = parseInt(localStorage.getItem(promoKey), 10);
        return t && (Date.now() - t) < promoDays * 864e5;
      } catch (e) { return false; }
    };
    var openPromo = function () {
      if (promo.getAttribute('data-open') === 'true') return;
      if (document.querySelector('[data-open="true"]')) return; /* don't stack on an open drawer/modal */
      promoLastFocus = document.activeElement;
      promo.hidden = false;
      void promo.offsetWidth; /* let the entrance transition run */
      trapOpen(promo);
      var panel = qs('.wt-promo__panel', promo);
      if (panel) panel.focus({ preventScroll: true });
    };
    var closePromo = function (remember) {
      if (promo.getAttribute('data-open') !== 'true') return;
      trapClose(promo);
      if (remember !== false) { try { localStorage.setItem(promoKey, String(Date.now())); } catch (e) {} }
      setTimeout(function () { if (promo.getAttribute('data-open') !== 'true') promo.hidden = true; }, 350);
      if (promoLastFocus && promoLastFocus.focus) promoLastFocus.focus({ preventScroll: true });
    };

    promo.addEventListener('click', function (e) {
      if (e.target.closest('[data-promo-close]')) { closePromo(); return; }
    });
    /* Capture phase: close the promo first, then the normal handler opens the Halloween form. */
    promo.addEventListener('click', function (e) {
      if (e.target.closest('[data-promo-cta]')) closePromo();
    }, true);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && promo.getAttribute('data-open') === 'true') closePromo();
    });

    if (window.Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:select', function (e) { if (promo.closest('#shopify-section-' + e.detail.sectionId)) openPromo(); });
      document.addEventListener('shopify:section:deselect', function (e) { if (promo.closest('#shopify-section-' + e.detail.sectionId)) closePromo(false); });
    } else if (!promoSeen()) {
      setTimeout(openPromo, promoDelay);
    }
  }

  /* ---------- Parallax photos (wt-hero, wt-callout: data-parallax="<strength %>") ----------
     The main photo is oversized by the travel range and translated as the hero crosses the
     viewport, so it moves slower than the page. Transform-only, rAF-throttled, and only while
     the hero is on screen. Skipped for reduced motion (photo stays at rest). */
  (function () {
    var heroes = qsa('[data-parallax]');
    if (!heroes.length) return;
    var rm = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
    if (rm.matches) return;
    var items = heroes.map(function (sec) {
      var frame = qs('[data-parallax-frame]', sec) || qs('.wt-hero__main', sec);
      if (!frame) return null;
      frame.classList.add('is-parallax');
      return { frame: frame, pct: (parseFloat(sec.getAttribute('data-parallax')) || 10) / 100, on: true, range: 0 };
    }).filter(Boolean);
    var ticking = false;
    function measure() {
      items.forEach(function (it) {
        it.range = Math.round(it.frame.offsetHeight * it.pct);
        it.frame.style.setProperty('--px-r', it.range + 'px');
      });
    }
    function update() {
      ticking = false;
      var vh = window.innerHeight;
      items.forEach(function (it) {
        if (!it.on) return;
        var r = it.frame.getBoundingClientRect();
        var t = (vh - r.top) / (vh + r.height);            /* 0 entering bottom -> 1 leaving top */
        var off = Math.max(-1, Math.min(1, t * 2 - 1));
        it.frame.style.setProperty('--px-y', (off * it.range).toFixed(1) + 'px');
      });
    }
    function request() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          items.forEach(function (it) { if (it.frame === e.target) it.on = e.isIntersecting; });
        });
        request();
      });
      items.forEach(function (it) { io.observe(it.frame); });
    }
    measure(); update();
    window.addEventListener('scroll', request, { passive: true });
    window.addEventListener('resize', function () { measure(); request(); });
    if (rm.addEventListener) rm.addEventListener('change', function (e) {
      if (e.matches) items.forEach(function (it) { it.on = false; it.frame.classList.remove('is-parallax'); });
    });
  })();

  /* ---------- FAQ (sections/wt-faq-nav, wt-faq topics, snippets/wt-faq-item) ----------
     Page-wide: smooth open/close on the native <details>, optional one-open-at-a-time per topic,
     live search across every topic, topic chips (built from the topic sections) that follow your
     scroll position, and #faq-q-<id> deep links. */
  (function () {
    var groups = qsa('[data-faq-group]');
    if (!groups.length) return;
    var rmq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
    var items = qsa('[data-faq-item]');

    function animateOpen(d, open) {
      var panel = qs('.wt-faq__a', d);
      var sec = d.closest('[data-faq]');
      if (d._anim) { d._anim.onfinish = null; d._anim.cancel(); d._anim = null; }
      d._closing = false;
      if (rmq.matches || !panel.animate || !(sec && sec.hasAttribute('data-animate'))) { d.open = open; return; }
      if (open) {
        d.open = true;
        d._anim = panel.animate([{ height: '0px', opacity: 0 }, { height: panel.scrollHeight + 'px', opacity: 1 }], { duration: 320, easing: 'cubic-bezier(.2,.8,.2,1)' });
      } else {
        d._closing = true;
        d._anim = panel.animate([{ height: panel.offsetHeight + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 240, easing: 'ease-in' });
        d._anim.onfinish = function () { d.open = false; d._anim = null; d._closing = false; };
      }
    }
    items.forEach(function (d) {
      qs('summary', d).addEventListener('click', function (e) {
        e.preventDefault();
        var opening = d._closing ? true : !d.open;
        var sec = d.closest('[data-faq]');
        if (opening && sec && sec.hasAttribute('data-faq-single')) qsa('[data-faq-item]', sec).forEach(function (o) { if (o !== d && o.open) animateOpen(o, false); });
        animateOpen(d, opening);
      });
    });

    /* Topic chips, built from the topic sections */
    var bar = qs('[data-faq-bar]');
    var rail = qs('[data-faq-rail]');
    var links = [];
    if (bar && rail && groups.length > 1) {
      groups.forEach(function (g) {
        if (!g.id) return;
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.className = 'wt-faq__chip';
        a.href = '#' + g.id;
        a.style.setProperty('--cat', getComputedStyle(g).getPropertyValue('--cat'));
        a.innerHTML = '<span class="wt-faq__dot" aria-hidden="true"></span>';
        a.appendChild(document.createTextNode(g.getAttribute('data-faq-title') || g.id));
        li.appendChild(a); rail.appendChild(li); links.push(a);
        a.addEventListener('click', function (e) {
          e.preventDefault();
          g.scrollIntoView({ behavior: rmq.matches ? 'auto' : 'smooth', block: 'start' });
          setActive(g.id);
          if (history.replaceState) history.replaceState(null, '', '#' + g.id);
        });
      });
      bar.hidden = false;
      var setBarH = function () { document.documentElement.style.setProperty('--faq-bar-h', bar.offsetHeight + 'px'); };
      setBarH(); window.addEventListener('resize', setBarH);
      /* Desktop arrows for the chip row */
      var prev = qs('[data-faq-prev]', bar), next = qs('[data-faq-next]', bar);
      var arrows = function () {
        var max = rail.scrollWidth - rail.clientWidth;
        var none = max <= 4;
        if (prev) { prev.disabled = rail.scrollLeft <= 2; prev.hidden = none; }
        if (next) { next.disabled = rail.scrollLeft >= max - 2; next.hidden = none; }
      };
      if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -rail.clientWidth * .7, behavior: rmq.matches ? 'auto' : 'smooth' }); });
      if (next) next.addEventListener('click', function () { rail.scrollBy({ left: rail.clientWidth * .7, behavior: rmq.matches ? 'auto' : 'smooth' }); });
      rail.addEventListener('scroll', arrows, { passive: true });
      window.addEventListener('resize', arrows);
      arrows();
      /* Shadow once the chip row is stuck */
      if ('IntersectionObserver' in window) {
        var sentinel = document.createElement('div');
        sentinel.setAttribute('aria-hidden', 'true');
        bar.parentNode.insertBefore(sentinel, bar);
        var hh = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--wt-header-h'), 10) || 84;
        new IntersectionObserver(function (es) {
          bar.classList.toggle('is-stuck', !es[0].isIntersecting && es[0].boundingClientRect.top < hh + 2);
        }, { rootMargin: '-' + (hh + 1) + 'px 0px 0px 0px' }).observe(sentinel);
      }
    }
    function setActive(id) {
      links.forEach(function (a) {
        var on = a.getAttribute('href') === '#' + id;
        if (on) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
        if (on && rail.scrollWidth > rail.clientWidth + 4) {
          rail.scrollTo({ left: a.parentNode.offsetLeft - rail.offsetLeft - 16, behavior: rmq.matches ? 'auto' : 'smooth' });
        }
      });
    }
    if (links.length && 'IntersectionObserver' in window) {
      var tops = {};
      var spy = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { tops[e.target.id] = e.isIntersecting ? e.boundingClientRect.top : null; });
        var best = null, bestTop = Infinity;
        groups.forEach(function (g) { var t = tops[g.id]; if (t != null && !g.hidden && t < bestTop) { bestTop = t; best = g.id; } });
        if (best) setActive(best);
      }, { rootMargin: '-' + ((parseInt(getComputedStyle(document.documentElement).getPropertyValue('--wt-header-h'), 10) || 84) + (bar ? bar.offsetHeight : 0) + 24) + 'px 0px -50% 0px' });
      groups.forEach(function (g) { if (g.id) spy.observe(g); });
      setActive(groups[0].id);
    }

    /* Live search across all topics */
    var search = qs('[data-faq-search]');
    var empty = qs('[data-faq-empty]');
    var results = qs('[data-faq-results]');
    if (search) {
      items.forEach(function (d) { d._text = d.textContent.toLowerCase().replace(/\s+/g, ' '); });
      var timer;
      search.addEventListener('input', function () {
        clearTimeout(timer);
        timer = setTimeout(function () {
          var q = search.value.trim().toLowerCase();
          var shown = 0;
          items.forEach(function (d) {
            var hit = !q || d._text.indexOf(q) !== -1;
            d.hidden = !hit;
            if (hit) { shown++; d.classList.add('is-inview'); }
          });
          groups.forEach(function (g) {
            var n = qsa('[data-faq-item]', g).filter(function (d) { return !d.hidden; }).length;
            g.hidden = n === 0;
            links.forEach(function (a) { if (a.getAttribute('href') === '#' + g.id) a.classList.toggle('is-dim', n === 0); });
          });
          if (empty) empty.hidden = shown > 0;
          if (results) results.textContent = q ? (shown === 1 ? '1 question matches' : shown + ' questions match') : '';
        }, 120);
      });
    }

    /* Deep link: #faq-q-<id> opens that question */
    if (location.hash.indexOf('#faq-q-') === 0) {
      var target = qs(location.hash);
      if (target) { target.open = true; target.classList.add('is-inview'); setTimeout(function () { target.scrollIntoView({ block: 'start' }); }, 60); }
    }
  })();

  /* ---------- Product image lightbox (sections/main-product.liquid) ----------
     Click/tap a product photo to open it full size over the promo-style overlay. Arrows / swipe
     to move between images, Esc / overlay / close button to dismiss; focus returns to the photo. */
  qsa('[data-lightbox]').forEach(function (box) {
    var section = box.closest('.wt-pdp') || document;
    var dataEl = qs('[data-lightbox-images]', section);
    var images = [];
    try { images = JSON.parse(dataEl ? dataEl.textContent : '[]'); } catch (e) { images = []; }
    if (!images.length) return;
    var img = qs('.wt-lightbox__img', box);
    var count = qs('[data-lightbox-index]', box);
    var closeBtn = qs('.wt-lightbox__close', box);
    var current = 0, opener = null;
    function show(i) {
      current = (i + images.length) % images.length;
      var it = images[current];
      img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.loading = 'eager';
      img.src = it.src; img.alt = it.alt || '';
      if (it.w) img.width = it.w; if (it.h) img.height = it.h;
      if (count) count.textContent = current + 1;
      [current + 1, current - 1].forEach(function (n) { var nx = images[(n + images.length) % images.length]; if (nx) { var pre = new Image(); pre.src = nx.src; } });
    }
    function open(i, from) {
      opener = from || null;
      show(i);
      box.hidden = false;
      void box.offsetWidth;
      trapOpen(box);
      if (closeBtn) closeBtn.focus({ preventScroll: true });
    }
    function close() {
      if (box.getAttribute('data-open') !== 'true') return;
      trapClose(box);
      setTimeout(function () { if (box.getAttribute('data-open') !== 'true') box.hidden = true; }, 320);
      if (opener) opener.focus({ preventScroll: true });
    }
    qsa('[data-lightbox-open]', section).forEach(function (btn) {
      btn.addEventListener('click', function () { open(parseInt(btn.getAttribute('data-lightbox-open'), 10) || 0, btn); });
    });
    qsa('[data-lightbox-close]', box).forEach(function (el) { el.addEventListener('click', close); });
    var prev = qs('[data-lightbox-prev]', box), next = qs('[data-lightbox-next]', box);
    if (prev) prev.addEventListener('click', function () { show(current - 1); });
    if (next) next.addEventListener('click', function () { show(current + 1); });
    document.addEventListener('keydown', function (e) {
      if (box.getAttribute('data-open') !== 'true') return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowRight' && images.length > 1) show(current + 1);
      else if (e.key === 'ArrowLeft' && images.length > 1) show(current - 1);
      else if (e.key === 'Tab') {
        var f = qsa('button:not([hidden])', box);
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
    /* Swipe left/right on the photo */
    var fig = qs('.wt-lightbox__figure', box), sx = null, sy = null;
    if (fig && images.length > 1) {
      fig.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
      fig.addEventListener('touchend', function (e) {
        if (sx === null) return;
        var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) show(current + (dx < 0 ? 1 : -1));
        sx = sy = null;
      }, { passive: true });
    }
  });

  /* ---------- Product gallery thumbs ---------- */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-media-thumb]');
    if (!thumb) return;
    var gallery = thumb.closest('[data-gallery]');
    if (!gallery) return;
    var id = thumb.getAttribute('data-media-thumb');
    qsa('[data-media-id]', gallery).forEach(function (el) {
      el.hidden = el.getAttribute('data-media-id') !== id;
      el.classList.toggle('is-active', el.getAttribute('data-media-id') === id);
    });
    qsa('[data-media-thumb]', gallery).forEach(function (el) {
      el.classList.toggle('is-active', el === thumb);
    });
  });

  /* ---------- Header height -> CSS var (anchor-link scroll offset) ---------- */
  var siteHeaderEl = qs('[data-header]');
  if (siteHeaderEl) {
    var setHeaderHeightVar = function () {
      document.documentElement.style.setProperty('--wt-header-h', siteHeaderEl.offsetHeight + 'px');
    };
    setHeaderHeightVar();
    window.addEventListener('load', setHeaderHeightVar);
    window.addEventListener('resize', setHeaderHeightVar);
  }

  /* ---------- Stockist widget (lazy-loaded on scroll into view) ---------- */
  var stockistLazyEls = qsa('[data-stockist-lazy]');
  if (stockistLazyEls.length) {
    var loadStockist = function (el) {
      if (el.getAttribute('data-stockist-loaded')) return;
      el.setAttribute('data-stockist-loaded', 'true');
      var src = el.getAttribute('data-stockist-src');
      if (!src) return;
      var script = document.createElement('script');
      script.src = src;
      script.async = true;
      document.body.appendChild(script);
    };
    if ('IntersectionObserver' in window) {
      var stockistObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          loadStockist(entry.target);
          stockistObserver.unobserve(entry.target);
        });
      }, { rootMargin: '200px 0px' });
      stockistLazyEls.forEach(function (el) { stockistObserver.observe(el); });
    } else {
      stockistLazyEls.forEach(loadStockist);
    }
  }

  /* ---------- Klaviyo newsletter subscribe (native Shopify customer forms) ----------
     Delegated so it covers both newsletter forms (contact-cta section + footer block)
     without duplicating this per section. These forms post straight to Shopify (full
     page submission), so the Klaviyo call is fired with keepalive so it survives the
     navigation instead of being cancelled - never awaited, never blocks the Shopify
     submission. Same Klaviyo Subscribe API used by the Halloween form
     (sections/halloween-form.liquid), just triggered on native submit instead of
     after a custom AJAX success. */
  document.addEventListener('submit', function (evt) {
    var form = evt.target;
    if (!form || !form.matches || !form.matches('form[data-kl-key][data-kl-list]')) return;
    var klKey = form.getAttribute('data-kl-key');
    var klList = form.getAttribute('data-kl-list');
    var emailField = form.querySelector('input[type="email"]');
    var email = emailField ? emailField.value.trim() : '';
    var consentField = form.querySelector('input[name="contact[accepts_marketing]"]');
    var consented = consentField ? consentField.checked : true;
    if (!klKey || !klList || !email || !consented || !window.fetch) return;
    var body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Newsletter signup',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
              }
            }
          }
        },
        relationships: { list: { data: { type: 'list', id: klList } } }
      }
    };
    fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(klKey), {
      method: 'POST',
      keepalive: true,
      headers: { revision: '2026-07-15', 'Content-Type': 'application/vnd.api+json' },
      body: JSON.stringify(body)
    }).catch(function () {});
  });

  /* ---------- Product page: What's inside counts follow the variant picked ----------
     Uses the variant's own counts (variant metafields) when it has them, otherwise the
     product's counts. Listens for wt:variant from the variant picker below. */
  qsa('[data-inside]').forEach(function (box) {
    var pdp = box.closest('.wt-pdp');
    if (!pdp) return;
    var base = (box.getAttribute('data-inside-base') || '').split(',').map(function (n) { return parseInt(n, 10) || 0; });
    var map = {};
    try { map = JSON.parse(qs('[data-inside-variants]', box).textContent) || {}; } catch (err) {}
    pdp.addEventListener('wt:variant', function (e) {
      var v = e.detail || {};
      var counts = map[v.id] || base;
      qsa('[data-inside-n]', box).forEach(function (li) {
        var c = counts[parseInt(li.getAttribute('data-inside-n'), 10)] || 0;
        var b = qs('b', li);
        if (b) b.textContent = '\u00d7' + c;
        li.hidden = c < 1;
      });
    });
  });

  /* ---------- Product page: nutrition pack selector (tabs) ---------- */
  qsa('[data-nutri]').forEach(function (box) {
    var tabs = qsa('[data-nutri-tab]', box);
    if (tabs.length < 2) return;
    function select(t, focus) {
      tabs.forEach(function (x) {
        var on = x === t;
        x.setAttribute('aria-selected', on ? 'true' : 'false');
        x.tabIndex = on ? 0 : -1;
      });
      qsa('[data-nutri-panel]', box).forEach(function (p) { p.hidden = p.getAttribute('data-nutri-panel') !== t.getAttribute('data-nutri-tab'); });
      if (focus) t.focus();
    }
    box._wtSelect = function (n) {
      var t = tabs.filter(function (x) { return x.getAttribute('data-nutri-tab') === n; })[0];
      if (t) select(t);
    };
    /* Keep Nutrition and Ingredients on the same pack */
    function syncOthers(t) {
      var pdp = box.closest('.wt-pdp') || document;
      qsa('[data-nutri]', pdp).forEach(function (other) {
        if (other !== box && other._wtSelect) other._wtSelect(t.getAttribute('data-nutri-tab'));
      });
    }
    box.addEventListener('click', function (e) {
      var t = e.target.closest('[data-nutri-tab]');
      if (t) { select(t); syncOthers(t); }
    });
    box.addEventListener('keydown', function (e) {
      var i = tabs.indexOf(document.activeElement);
      if (i < 0) return;
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
        e.preventDefault();
        var nt = tabs[(i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length];
        select(nt, true);
        syncOthers(nt);
      }
    });
  });

  /* ---------- Product page: variant picker ---------- */
  qsa('.wt-pdp').forEach(function (pdp) {
    var dataEl = qs('[data-pdp-variants]', pdp);
    var idInput = qs('[data-pdp-variant]', pdp);
    if (!dataEl || !idInput) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }
    var addBtn = qs('[data-add-to-cart]', pdp);
    var addLabel = qs('[data-pdp-add-label]', pdp);
    var priceBox = qs('[data-pdp-price]', pdp);
    var soldOut = addLabel ? addLabel.getAttribute('data-sold-out') : '';
    var addText = addLabel ? addLabel.getAttribute('data-add') : '';
    pdp.addEventListener('change', function (e) {
      if (!e.target.matches('[data-pdp-option]')) return;
      var chosen = [];
      qsa('[data-pdp-options] fieldset', pdp).forEach(function (fs, i) {
        var checked = qs('input:checked', fs);
        chosen[i] = checked ? checked.value : null;
        var label = qs('[data-pdp-option-value="' + i + '"]', pdp);
        if (label && checked) label.textContent = checked.value;
      });
      var match = variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === chosen[i]; });
      })[0];
      if (!match) {
        if (addBtn) addBtn.setAttribute('disabled', 'disabled');
        if (addLabel) addLabel.textContent = addLabel.getAttribute('data-unavailable') || soldOut;
        return;
      }
      idInput.value = match.id;
      pdp.dispatchEvent(new CustomEvent('wt:variant', { detail: match }));
      if (priceBox) {
        var tmp = document.createElement('div');
        tmp.innerHTML = match.price;
        var oldPrice = qs('.price', priceBox);
        if (oldPrice && tmp.firstElementChild) oldPrice.replaceWith(tmp.firstElementChild);
      }
      if (addBtn) {
        if (match.available) addBtn.removeAttribute('disabled'); else addBtn.setAttribute('disabled', 'disabled');
      }
      if (addLabel) addLabel.textContent = match.available ? addText : soldOut;
      if (match.media) {
        var slide = qs('[data-media-id="' + match.media + '"]', pdp);
        var rail = qs('[data-pdp-media]', pdp);
        if (slide && rail) {
          if (rail.scrollWidth > rail.clientWidth + 4) rail.scrollTo({ left: slide.offsetLeft - rail.offsetLeft, behavior: 'smooth' });
          else slide.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      }
      if (window.history && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        history.replaceState({}, '', url.toString());
      }
    });

    /* Mobile swipe gallery: "2 / 5" counter */
    var rail = qs('[data-pdp-media]', pdp);
    var idx = qs('[data-pdp-index]', pdp);
    if (rail && idx) {
      var tick = false;
      rail.addEventListener('scroll', function () {
        if (tick) return;
        tick = true;
        requestAnimationFrame(function () {
          var w = rail.firstElementChild ? rail.firstElementChild.offsetWidth : rail.clientWidth;
          idx.textContent = Math.min(rail.children.length, Math.round(rail.scrollLeft / Math.max(1, w)) + 1);
          tick = false;
        });
      }, { passive: true });
    }
  });

  /* ---------- Product recommendations (fetched after load, never blocks the page) ---------- */
  qsa('[data-recs-url]').forEach(function (box) {
    var load = function () {
      fetch(box.getAttribute('data-recs-url'))
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var fresh = tmp.querySelector('[data-recs-url]');
          if (fresh && fresh.innerHTML.trim()) box.innerHTML = fresh.innerHTML;
        })
        .catch(function () {});
    };
    if (!('IntersectionObserver' in window)) { load(); return; }
    var io = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) { io.disconnect(); load(); }
    }, { rootMargin: '800px 0px' });
    io.observe(box);
  });

  /* ---------- Collection sorting ---------- */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-collection-sort]');
    if (!sel) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sel.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  /* Collection filters: only one dropdown open at a time */
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d.classList || !d.classList.contains('wt-filter') || !d.open) return;
    qsa('.wt-filter[open]').forEach(function (o) { if (o !== d) o.open = false; });
  }, true);

  /* ---------- Announcement bar rotation ---------- */
  qsa('[data-announce-autoplay]').forEach(function (bar) {
    var items = qsa('.announce-bar__item', bar);
    if (items.length < 2) return;
    var seconds = parseInt(bar.getAttribute('data-announce-autoplay'), 10) || 5;
    var index = 0;
    setInterval(function () {
      items[index].hidden = true;
      index = (index + 1) % items.length;
      items[index].hidden = false;
    }, seconds * 1000);
  });
  /* ---------- Wild flavours trail (sections/wt-flavour-trail.liquid) ----------
     Tap a mystery bug to reveal it; "Reveal them all" opens a whole stop. A counter and bar
     track how many have been found, and the finish line celebrates when every one is found. */
  qsa('[data-trail]').forEach(function (trail) {
    var total = parseInt(trail.getAttribute('data-trail-total'), 10) || 0;
    var countEl = qs('[data-trail-count]', trail);
    var meter = qs('[data-trail-meter]', trail);
    var live = qs('[data-trail-live]', trail);
    var doneText = (qs('.wt-finish__done', trail) || {}).textContent || '';
    var floatEl = qs('[data-trail-float]', trail);
    var floatCount = qs('[data-trail-float-count]', trail);
    var floatBar = floatEl ? qs('.wt-trail__float-meter span', floatEl) : null;
    var progressEl = qs('.wt-trail__progress', trail);
    var finishEl = qs('[data-trail-finish]', trail);
    function found() { return qsa('.wt-bug.is-found', trail).length; }
    function reveal(btn) {
      if (btn.classList.contains('is-found')) return false;
      btn.classList.add('is-found');
      btn.setAttribute('aria-label', (btn.getAttribute('data-name') || '') + ', found');
      return true;
    }
    function update(msg) {
      var n = found();
      if (countEl) countEl.textContent = n;
      if (meter) {
        meter.setAttribute('aria-valuenow', n);
        var bar = qs('span', meter);
        if (bar && total) bar.style.width = Math.round(n * 100 / total) + '%';
      }
      if (floatCount) floatCount.textContent = n;
      if (floatBar && total) floatBar.style.width = Math.round(n * 100 / total) + '%';
      qsa('[data-trail-stop]', trail).forEach(function (stop) {
        var all = qs('[data-trail-all]', stop);
        if (all) all.hidden = !qs('.wt-bug:not(.is-found)', stop);
      });
      var complete = total > 0 && n >= total;
      var was = trail.classList.contains('is-complete');
      trail.classList.toggle('is-complete', complete);
      if (live && msg) live.textContent = msg + ' ' + n + ' of ' + total + ' found.' + (complete && !was && doneText ? ' ' + doneText.trim() : '');
    }
    trail.addEventListener('click', function (e) {
      var bug = e.target.closest('[data-trail-bug]');
      if (bug && trail.contains(bug)) {
        if (reveal(bug)) update(bug.getAttribute('data-name') + '!');
        return;
      }
      var allBtn = e.target.closest('[data-trail-all]');
      if (allBtn && trail.contains(allBtn)) {
        var stop = allBtn.closest('[data-trail-stop]');
        var names = [];
        qsa('[data-trail-bug]', stop).forEach(function (b) { if (reveal(b)) names.push(b.getAttribute('data-name')); });
        if (names.length) update(names.join(', ') + '.');
        var first = qs('[data-trail-bug]', stop);
        if (first) first.focus();
      }
    });
    update();

    /* Floating tracker: visible after the intro tracker scrolls above the screen, hidden once
       the finish line comes into view (or the trail ends). Tap it when complete to jump there. */
    if (floatEl && progressEl) {
      var ticking = false;
      var placeFloat = function () {
        ticking = false;
        var vh = window.innerHeight;
        var past = progressEl.getBoundingClientRect().bottom < 0;
        var endEl = finishEl || qs('.wt-trail__stops', trail);
        var endRect = endEl.getBoundingClientRect();
        var extra = parseInt(floatEl.getAttribute('data-trail-float-offset'), 10) || 0;
        var beforeEnd = finishEl ? endRect.top > vh - 40 - extra : endRect.bottom > vh - extra;
        floatEl.classList.toggle('is-visible', past && beforeEnd);
      };
      var onScroll = function () { if (!ticking) { ticking = true; requestAnimationFrame(placeFloat); } };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      placeFloat();
      floatEl.addEventListener('click', function () {
        if (trail.classList.contains('is-complete') && finishEl) finishEl.scrollIntoView({ behavior: reducedMotion.matches ? 'auto' : 'smooth', block: 'center' });
      });
    }
  });
})();
